module.exports = __webpack_public_path__ + "img/training-cycling.50aa0989.svg";